/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubmissionChannel = {
    Sms: 'sms',
    WhatsappMember: 'whatsapp_member',
    WhatsappDirect: 'whatsapp_direct',
    Upload: 'upload',
} as const;
export type SubmissionChannel = typeof SubmissionChannel[keyof typeof SubmissionChannel];


export function instanceOfSubmissionChannel(value: any): boolean {
    for (const key in SubmissionChannel) {
        if (Object.prototype.hasOwnProperty.call(SubmissionChannel, key)) {
            if (SubmissionChannel[key as keyof typeof SubmissionChannel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubmissionChannelFromJSON(json: any): SubmissionChannel {
    return SubmissionChannelFromJSONTyped(json, false);
}

export function SubmissionChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionChannel {
    return json as SubmissionChannel;
}

export function SubmissionChannelToJSON(value?: SubmissionChannel | null): any {
    return value as any;
}

export function SubmissionChannelToJSONTyped(value: any, ignoreDiscriminator: boolean): SubmissionChannel {
    return value as SubmissionChannel;
}

